<app-navigation-bar></app-navigation-bar>

<router-outlet></router-outlet>


<!-- <app-home></app-home> -->
<!-- <app-detailed-page></app-detailed-page> -->
<!-- <app-subscriptions-page></app-subscriptions-page> -->